export { default as ModalUpsize } from './modal-upsize';
